import { FileStateFilter } from '@features/investigations/utils/constants';
import { FacetedFilterOperator } from '@shared/api/findings/findings.types';
import { type FacetedFilter } from '@shared/api/findings/findings.types';

export function getFiltersZeroCount(filters: FacetedFilter[], filterSearch: string): FacetedFilter[] {
  const filteredFilters = filters.map((f) => ({
    ...f,
    options: f.options.filter((opt) => opt.value !== ''),
  }));
  const search = filterSearch.trim().toLowerCase();
  const searchedFilters = search
    ? filteredFilters.filter((f) => f.label.toLowerCase().includes(search))
    : filteredFilters;
  const filtersZeroCount: FacetedFilter[] = [];
  for (const filter of searchedFilters) {
    const totalCount = filter.options.reduce((acc, opt) => acc + (opt.count ?? 0), 0);
    if (totalCount === 0) {
      filtersZeroCount.push(filter);
    }
  }
  return filtersZeroCount;
}

export function normalizeOperator(op: unknown): FacetedFilterOperator {
  if (op === FacetedFilterOperator.IS) return FacetedFilterOperator.IS;
  if (op === FacetedFilterOperator.NOT) return FacetedFilterOperator.NOT;
  return FacetedFilterOperator.IS;
}

export type OpenClosedStateLabel = FileStateFilter.OPEN | FileStateFilter.CLOSED | null;

interface BuildFindingsTitleParams {
  isLoaded: boolean;
  stateLabel: OpenClosedStateLabel;
  name: string | null | undefined;
  fallbackName: string;
}

export function buildFindingsTitle({
  isLoaded,
  stateLabel,
  name,
  fallbackName,
}: BuildFindingsTitleParams): string | null {
  if (!isLoaded) return null;
  const resolvedName = name ?? fallbackName;
  return [stateLabel, resolvedName].filter(Boolean).join(': ');
}

export function getOpenClosedStateLabel(isOpen: boolean | undefined): OpenClosedStateLabel {
  if (isOpen === true) return FileStateFilter.OPEN;
  if (isOpen === false) return FileStateFilter.CLOSED;
  return null;
}

export function getOpenClosedStateLabelFromState(state: string | null | undefined): OpenClosedStateLabel {
  if (state === FileStateFilter.OPEN) return FileStateFilter.OPEN;
  if (state === FileStateFilter.CLOSED) return FileStateFilter.CLOSED;
  return null;
}

export function hasFindingsToExport(totalFindings: number | null | undefined, isEligible = true): boolean {
  return isEligible && (totalFindings ?? 0) > 0;
}
